import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import ReduxThunk from 'redux-thunk'

import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  timeout: 500
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = createStore(
  persistedReducer,
  applyMiddleware(ReduxThunk)
);

export default () => {
  let persistor = persistStore(store)
  return { store, persistor }
}